'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FontFace = require('react-canvas/lib/FontFace');

var _FontFace2 = _interopRequireDefault(_FontFace);

var _measureText = require('react-canvas/lib/measureText');

var _measureText2 = _interopRequireDefault(_measureText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* injects from baggage-loader */

exports.default = function (_ref) {
  var text = _ref.text;
  var _ref$maxWidth = _ref.maxWidth;
  var maxWidth = _ref$maxWidth === undefined ? +Infinity : _ref$maxWidth;
  var _ref$fontFamily = _ref.fontFamily;
  var fontFamily = _ref$fontFamily === undefined ? 'sans-serif' : _ref$fontFamily;
  var _ref$fontSize = _ref.fontSize;
  var fontSize = _ref$fontSize === undefined ? 14 : _ref$fontSize;
  var _ref$lineHeight = _ref.lineHeight;
  var lineHeight = _ref$lineHeight === undefined ? fontSize * 1.3 : _ref$lineHeight;
  return (0, _measureText2.default)(text, maxWidth, (0, _FontFace2.default)(fontFamily), fontSize, lineHeight);
};


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/utils/measureText.js
// module id = 140
// module chunks = 1